module.exports = __webpack_public_path__ + "static/logoinvert-797bf68094040d075f29489edcc0039c.png";